import { notFound, redirect } from "@tanstack/react-router";
import { getArtistDirectoryIdentity, getArtistDirectoryQueryOptions } from "@/features/feature-page/artist-directory-query";
import { getFeaturePageQueryOptions } from "@/features/feature-page/feature-page-query";
import { buildFeaturePagePath } from "@garimpa/lib/buildFeaturePagePath";
const SplitLoader = async ({
  context: {
    queryClient,
    locale,
    featurePageFamily
  },
  params,
  location
}) => {
  const page = await queryClient.ensureQueryData(getFeaturePageQueryOptions({
    family: featurePageFamily,
    slug: params.slug,
    locale
  }));
  if (!page) throw notFound();
  if (page.page.canonicalSlug !== params.slug) {
    throw redirect({
      href: buildFeaturePagePath(locale, featurePageFamily, page.page.canonicalSlug),
      statusCode: 301
    });
  }
  const directory = getArtistDirectoryIdentity(page);
  if (directory) {
    await queryClient.ensureQueryData(getArtistDirectoryQueryOptions(directory, location.search as ArtistDirectorySearchState));
  }
  return {
    family: featurePageFamily,
    locale,
    page,
    slug: params.slug
  };
};
export { SplitLoader as loader };